module.exports = __webpack_public_path__ + "Gotham-Rounded-Medium.dffb2b80813d195d26fa.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/Admin/Documents/Dev Projects/search-artist/src/assets/fonts/Gotham-Rounded-Medium.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Rounded-Medium.ttf
// module chunks = styles